export const LicenseLogSummaryMockData = [
  {
    licenseDataId: '821969d5-1c4f-4ed8-a56d-4d9b9a9f656e',
    licenseCreatedByName: 'Mock License Created By Name',
    logType: 'LicenseCreation',
    userName: 'Mock License User Name',
    createdOn: '2023-06-16T17:06:43.5073342-04:00',
    organizationName: 'Mock License Organization',
    toolCode: '1234',
    deviceType: 'GLC',
    description: 'LicenseCreation',
  },
] as any[];
